import src from "IMAGE";
export default { src, width: 272, height: 80, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AE5IUs1TUl/jQTw/WFFRUUpGRkY/V1dXUzw8PDYwMDArAHCInNNphpzoQUNIVF5eXlVoaGhfYGBgWWhoaF1ra2tg9L0Xq9ufIowAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
